import {
  ModalWithAccordionProps,
  ModalWithAccordion,
} from '@kizi/comparator-components';
import { IWizardContext, WizardContext } from '@kizi/comparator-core';
import { Div, DivProps } from '@kizi/core-components';
import React, { useContext } from 'react';
const Flex = (props) => <Div {...props} display="flex" />;

interface HeaderProps extends DivProps {
  activeStep: number;
  faq: ModalWithAccordionProps;
}

export const Header: React.FC<HeaderProps> = ({
  activeStep,
  faq,
  ...divProps
}) => {
  const { wizardService } = useContext<IWizardContext>(WizardContext);
  if (!wizardService) return null;

  return (
    <Div bg="white" py={4} px={3} {...divProps}>
      <Flex
        style={{
          maxWidth: '1180px',
          width: '100%',
          margin: 'auto',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Flex flexGrow={1} />
        <Flex flexGrow={1} justifyContent="center" />
        <Flex flexGrow={1} justifyContent="flex-end">
          {faq && <Div>{<ModalWithAccordion {...faq} />}</Div>}
        </Flex>
      </Flex>
    </Div>
  );
};

export default Header;
